// 모바일 업무 등록/수정 폼 (view/mobile/work/form.html) — Phase G(2026-09-18)
//
// 데스크톱 업무 모달(view/work/list.html 의 openEdit/submitReg)의 모바일 전체 페이지판. 서버 API 는 데스크톱 것을 그대로 호출한다.
//   비연계  POST /work/api              · GET/PUT/DELETE /work/api/{seq}
//   소송    POST /suit/api/{id}/work    · GET/PUT/DELETE /suit/api/{id}/work/{seq}
//   의뢰인  POST /client/api/{id}/work  · GET/PUT/DELETE /client/api/{id}/work/{seq}
// apiBase 는 컨트롤러가 계산해 루트 data-api 로 내려준다(등록 = apiBase, 단건 = apiBase + '/' + seq).
// 권한은 서버 판정: mode 'work-memo'(타인 글) 이면 공유메모만 수정(lockAll), deletable/shareable 도 서버 값.
// 루트 data-* 는 init() 에서만 읽는다(메서드 안의 this.$el 은 호출 요소라 루트가 아님).
// 삭제 확인은 바깥 x-data="confirmDialog" 스코프의 confirm() — 이 컴포넌트에 title/message 프로퍼티를 두지 말 것(이름 충돌).
export default () => ({
    apiBase: '',
    seq: '',
    backUrl: '/m/work/list',
    me: '',
    shareEnabled: false,   // 비연계만 공유자 UI(서버 shareable 과 AND)
    aamUsers: [],
    loading: false,
    loadFailed: false,
    submitting: false,
    editing: null,         // { mode, deletable, shareable, writerId }
    form: {},

    init() {
        const d = this.$el.dataset;
        this.apiBase = d.api || '';
        this.seq = d.seq || '';
        this.me = d.me || '';
        this.shareEnabled = d.share === 'true';
        this.aamUsers = (window.M_WORK_FORM && window.M_WORK_FORM.aamUsers) || [];
        let back = d.back || '/m/work/list';
        // 업무 목록에서 들어온 경우(비연계 · 목록 시트 [수정]) 필터가 보존된 목록 URL 로 복귀
        if (d.fromList === 'true') {
            try { back = sessionStorage.getItem('mWorkListUrl') || back; } catch (e) { /* 저장소 차단 환경 */ }
        }
        this.backUrl = back;
        this.form = this.defaultForm();
        if (this.seq) this.load();
    },

    get isEdit() { return !!this.seq; },
    get lockAll() { return this.editing !== null && this.editing.mode === 'work-memo'; },
    get showShare() { return this.shareEnabled && (!this.isEdit || (this.editing !== null && this.editing.shareable)); },
    get gubunLabel() { return ({ '1': '알림', '2': '업무', '3': '상담', '4': '약속', '5': '메모' })[this.form.gubun] || '업무'; },
    get ustatusLabel() { return ({ '1': '진행', '2': '대기', '3': '보류', '4': '취소', '5': '완료', '9': '기타' })[this.form.ustatus] || '—'; },
    get timeLabel() {
        if (this.form.noTime) return '시간 없음';
        return (this.form.time || '—') + (this.form.spentMin ? ' · 소요 ' + this.form.spentMin + '분' : '');
    },
    // 공유자 후보 = 전체 유저 − 등록자(등록 = 로그인 유저, 수정 = 글의 등록자 — 등록자는 항상 접근 보유)
    get shareCandidates() {
        const excl = this.editing ? this.editing.writerId : this.me;
        return this.aamUsers.filter(u => u.userid !== excl);
    },
    get shareAllChecked() {
        const n = this.shareCandidates.length;
        return n > 0 && (this.form.shareUserIds ? this.form.shareUserIds.length : 0) === n;
    },
    toggleShareAll(checked) {
        this.form.shareUserIds = checked ? this.shareCandidates.map(u => u.userid) : [];
    },

    defaultForm() {
        const d = new Date();
        const today = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
        return { gubun: '2', ustatus: '1', date: today, time: '09:00', noTime: true, spentMin: '', content: '', sharedMemo: '', shareUserIds: [] };
    },

    async load() {
        this.loading = true;
        try {
            const json = await this.$mapi(this.apiBase + '/' + this.seq);
            const data = json.data || {};
            this.form = Object.assign(this.defaultForm(), data.form || {});
            // 연계 API(소송·의뢰인)는 유형을 form.gubun 이 아니라 sel('w' + gubun — 데스크톱 진행사항 모달의 선택 키)로 준다.
            // 반영하지 않으면 기본값 '2' 가 PUT 으로 나가 유형이 업무로 덮어써진다.
            if (!(data.form && data.form.gubun) && typeof data.sel === 'string' && data.sel.charAt(0) === 'w') {
                this.form.gubun = data.sel.substring(1);
            }
            if (!Array.isArray(this.form.shareUserIds)) this.form.shareUserIds = [];
            this.editing = { mode: data.mode, deletable: !!data.deletable, shareable: !!data.shareable, writerId: data.writerId || '' };
        } catch (e) {
            if (e.message === 'SESSION') return;
            this.loadFailed = true;
            this.toast('error', '조회 실패', e.message || '업무를 불러오지 못했습니다.');
        } finally {
            this.loading = false;
        }
    },

    async submit() {
        if (this.submitting || this.loading || this.loadFailed) return;
        // 제한 모드(공유메모만)는 편집 불가 필드 검증 생략 — 데스크톱 submitReg 미러
        if (!this.lockAll && !this.form.date) {
            this.toast('warning', '입력 확인', '일자를 입력하세요.');
            this.$refs.dateInput?.focus();
            return;
        }
        if (!this.lockAll && this.form.gubun !== '5' && !this.form.noTime && !this.form.time) {
            this.toast('warning', '입력 확인', '시간을 선택하세요.');
            this.$refs.timeInput?.focus();
            return;
        }
        const label = this.isEdit ? '수정' : '등록';
        this.submitting = true;
        try {
            await this.$mapi(this.isEdit ? this.apiBase + '/' + this.seq : this.apiBase, {
                method: this.isEdit ? 'PUT' : 'POST',
                body: {
                    gubun: this.form.gubun, ustatus: this.form.ustatus, date: this.form.date,
                    noTime: this.form.noTime, time: this.form.time, spentMin: this.form.spentMin,
                    content: this.form.content, sharedMemo: this.form.sharedMemo,
                    shareUserIds: this.form.shareUserIds
                }
            });
            this.leave();
        } catch (e) {
            if (e.message === 'SESSION') return;
            this.toast('error', label + ' 실패', e.message || (label + ' 중 오류가 발생했습니다.'));
            this.submitting = false;
        }
    },

    // confirmDialog 콜백에서 호출 — 확인 자체는 템플릿의 confirm()(바깥 스코프)
    async remove() {
        if (this.submitting) return;
        this.submitting = true;
        try {
            await this.$mapi(this.apiBase + '/' + this.seq, { method: 'DELETE' });
            this.leave();
        } catch (e) {
            if (e.message === 'SESSION') return;
            this.toast('error', '삭제 실패', e.message || '삭제 중 오류가 발생했습니다.');
            this.submitting = false;
        }
    },

    // 저장/삭제 후 복귀 — replace 로 폼을 히스토리에서 제거(뒤로가기로 폼 재진입·중복 저장 방지)
    leave() { window.location.replace(this.backUrl); },
    cancel() {
        if (window.history.length > 1) window.history.back();
        else window.location.href = this.backUrl;
    },

    toast(type, title, message) {
        window.dispatchEvent(new CustomEvent('show-toast', { detail: { type, title, message } }));
    }
});
